/// equipeagiliza.jsx

// nomeVendedor.js
export const nomeVendedor = [
  { nome: "Selecione", value: 0, cpf: 0 },
  { nome: "Kallebe", value: 1 , cpf: 0 },
  { nome: "Isis", value: 2 , cpf: 0 },
  { nome: "Samara", value: 3 , cpf: 0 },
  { nome: "Gabriel", value: 4 , cpf: 0 },
  { nome: "Bianca", value: 5 , cpf: 0 },
  { nome: "Yehudi", value: 6 , cpf: 0 },
  { nome: "Sr. Claudio", value: 7 , cpf: 0 },
  { nome: "Sarah", value: 8 , cpf: 0 },
  { nome: "Outro", value: 99 , cpf: 0 }
];




export const permission = [
  {
    nome: "Visitante",
    value: 0
  },
  {
    nome: "Vendedor",
    value: 1
  },
  {
    nome: "ADM",
    value: 99
  },
  {
    nome: "Produtor",
    value: 2
  },
  {
    nome: "Parceiro",
    value: 3
  },
]

export const statusDS160 = [

  {
    nome: "Status  Produção",
    value: 0
  },
  {
    nome: "Aguardando Rascunho",
    value: 2
  },
  {
    nome: "Rascunho OK, Boleto OK",
    value: 3
  },
  {
    nome: "Alterar informações",
    value: 4
  },
  {
    nome: "Finalizado",
    value: 1
  },


]

export const nomeProdutor = [
  {
    nome: "Selecione",
    value: 0, cpf: 0 
  },
  {
    nome: "Bianca",
    value: 1, cpf: 0 
  },
  {
    nome: "Yehudi",
    value: 2, cpf: 0 
  },
  {
    nome: "Sr Cláudio",
    value: 3, cpf: 0 
  },
  {
    nome: "Gabriel",
    value: 4, cpf: 0 
  },
]

export const nomeProdutor2 = [
  "Selecione",
  "Bianca",
  "Yehudi",
  "Sr Cláudio",
  "Gabriel"
]


export const fonteLeads = [
  {
    nome: "Selecione",
    value: 0
  },
  {
    nome: "parceiros",
    value: 1
  },
  {
    nome: "AnuncioON",
    value: 10
  },
  {
    nome: "NovaLP",
    value: 11
  },
  {
    nome: "lead online",
    value: 2
  },
  {
    nome: "lead programado",
    value: 3
  },
  {
    nome: "indicação particular",
    value: 4
  },
  {
    nome: "sem identificação",
    value: 5
  },
  {
    nome: "instagram",
    value: 6
  },
  {
    nome: "facebook",
    value: 7
  },
  {
    nome: "google",
    value: 8
  },
  {
    nome: "tiktok",
    value: 9
  },
  {
    nome: "outro",
    value: 99
  },

]



